import React from "react";

export interface CallMeetingContextProps {
  id?: string;
  title?: string;
  summary?: string;
  duration?: string;
  prospect?: string;
  salesRep?: string;
  modifiedDate?: string;
  score?: number;
}

export const CallMeetingContext = React.createContext<CallMeetingContextProps>(
  {},
);
